<template lang="html">

    <form class="login-form column-center" @submit.prevent="login" v-if="this.$route.params.id != null">

        <a href="/login" class="btn-volver-login"><img class="back-arrow" src="/static/img/blue-down-arrow.svg"> VOLVER</a>

        <h1 class="main-title" v-if="!!logindata.eAmbito" v-html="titulo[logindata.eAmbito]"></h1>
        <h1 class="main-title" v-else>Login</h1>

        <div class="contenedor-input">
            <label for="">{{(logindata.eAmbito=="PrivadoEmpresa") ? "Usuario" : "DNI"}} <popup-info v-if="!!logindata.eAmbito" :texto="logindata.eAmbito" :side="'left'"></popup-info></label>
            <input type="text" v-model="logindata.eUsuario" v-validate="'required'">
        </div>

        <div class="contenedor-input">
            <label for="">Contraseña</label>
            <input type="password" v-model="logindata.ePassword" v-validate="'required'">
        </div>

        <!-- <div class="contenedor-checks row-between">
            <div class="contenedor-check -radio">
                <input type="radio" id="alumni" name="ambito"
                    v-model="logindata.eAmbito" value="PrivadoAlumnoEmpleo" v-validate="'required'">
                <label for="alumni">Antiguos alumnos</label>
            </div>
            <div class="contenedor-check -radio">
                <input type="radio" id="estudiantes" name="ambito"
                    v-model="logindata.eAmbito" value="PrivadoEstudiante" v-validate="'required'">
                <label for="estudiantes">Estudiante</label>
            </div>
            <div class="contenedor-check -radio">
                <input type="radio" id="empresas" name="ambito"
                    v-model="logindata.eAmbito" value="PrivadoEmpresa" v-validate="'required'">
                <label for="empresas">Empresa</label>
            </div>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('ambito') }}</span>
        </div> -->

        <button class="btn" @click="login" :loading="loading">Acceder</button>

        <p class="forget-pass" v-if="!!logindata.eAmbito">He olvidado <a @click="$emit('setRecordar',logindata.eAmbito)">mi contraseña</a></p>
        
        <p class="register" v-if="logindata.eAmbito == 'PrivadoEmpresa'">¿Aún no estás <router-link :to="$t('enlaces.nuevaempresa')">registrado</router-link>?</p>
        
        <p class="register" v-if="logindata.eAmbito == 'PrivadoAlumnoEmpleo'">¿Aún no estás <a target="_blank" href="https://back.practicasyempleoufv.es/es/general/empleo-registro">registrado</a>?</p>
        
        <p class="register" v-if="logindata.eAmbito == 'PrivadoEstudiante'">¿Aún no estás <router-link :to="$t('enlaces.altaestudiantes')">registrado</router-link>?</p>
        
        
        
        <p class="forget-pass" v-if="!!!logindata.eAmbito" @click="validar">He olvidado <a>mi contraseña</a></p>
        <p class="register" v-if="!!!logindata.eAmbito" @click="validar">¿Aún no estás <a>registrado</a>?</p>


    </form>

    <form class="login-form column-center" @submit.prevent="login" v-else>

        <h1 class="main-title">Selecciona tu perfil</h1>

        <div class="fila-img-ambitos-login">
            <div class="mini-estudiante"><a href="/login/alumnos">
                <label>Estudiante</label>
            </a></div>
            <div class="mini-antiguo-alumno"><a href="/login/alumni">
                <label>Antiguo alumno</label>
            </a></div>
            <div class="mini-empresa"><a href="/login/empresas">
                <label>Empresa</label>
            </a></div>
        </div>

    </form>

</template>

<script lang="js">


    import {mapGetters , mapActions} from 'vuex';

    import router from '@/router';

    import popupInfo from '@/components/parts/popup-info';

    import VeeValidate from 'vee-validate';

    export default {
        name: 'formulario',
        mounted(){
            if(!!this.$route.params.id){
                this.logindata.eAmbito = this.ambitos[this.$route.params.id];
            }else{
                this.how = "empresas";
            }
        },
        data(){
            return{
                logindata : {
                    eUsuario : '',
                    ePassword : '',
                    eAmbito : ''
                },
                loading : false,
                clicked : false,
                ambitos : {
                    'empresas' : 'PrivadoEmpresa',
                    'estudiantes' : 'PrivadoEstudiante',
                    'alumnos' : 'PrivadoEstudiante',
                    'alumni' : 'PrivadoAlumnoEmpleo',
                    'antiguos' : 'PrivadoAlumnoEmpleo'
                },
                titulo : {
                    'PrivadoEmpresa' : 'Acceso<br>Empresas',
                    'PrivadoEstudiante' : 'Acceso<br>estudiantes',
                    'PrivadoAlumnoEmpleo' : 'Acceso<br>Antiguos alumnos',
                }
            }
        },
        methods:{
            ...mapActions(['requestLogin']),
            login(){

                this.clicked = true;

                this.$validator.validateAll().then(canSend => {
                    
                    if (canSend) {
                           
                        this.loading = true;
                        this.requestLogin(this.logindata)
                        .then(r =>{
                            if(r){
                                this.$router.push({name : 'home'})
                            }
                        }).finally(e => {
                            this.loading = false;
                        });
                    }
                });
            },
            validar(){
                this.clicked = true;
                this.$validator.validate('ambito');
            }
        },
        components : {
            'popup-info': popupInfo,
        }
    }
</script>

<style scoped lang="scss">

    @import "@/assets/css/colors.scss";

    .contenedor-input{
        label{
            color:$blue;
        }
    }

    .btn-volver-login{
        position: absolute;
        left: 85%;
        top: 3%;
    }

    .back-arrow{
        width: 14px;
        height: 14px;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .fila-img-ambitos-login{
        width:100%;
        display: flex;
    }

    @media (max-width: 575px) {
        .fila-img-ambitos-login {
            flex-direction: column;
        }
    }

    .fila-img-ambitos-login > div{
        flex: 1;
        min-height: 170px;
        margin: 5px;
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .fila-img-ambitos-login > .mini-antiguo-alumno {
        background-image: url(/static/img/mini-login-antiguo-alumno.png);
    }

    .fila-img-ambitos-login > .mini-empresa {
        background-image: linear-gradient(to top, #00000040, #04173840), url(/static/img/mini-login-empresa.png);        
    }

    .fila-img-ambitos-login > .mini-estudiante {
        background-image: url(/static/img/mini-login-estudiante.png);
    }

    .fila-img-ambitos-login > div a {
        width: 100% !important;
        height: 100% !important;
        display: block;
        cursor: pointer;
    }

    .fila-img-ambitos-login > div a label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        width: 96%;
    }

    .fila-img-ambitos-login > div a label::after {
        content: "";
        display: block;
        width: 20%;
        border-bottom: 3px solid #FAB536;
        position: absolute;
        bottom: -50%;
        left: 40%;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/components/view-parts/login/formulario.vue